const traverseAndFlatten = (currentNode: any, target: any, flattenedKey?: any) => {
  for (const key in currentNode) {
    if (Object.hasOwn(currentNode, key)) {
      let newKey: string;
      if (flattenedKey === undefined) {
        newKey = key;
      } else {
        newKey = `${flattenedKey}.${key}`;
      }

      const value = currentNode[key];
      if (typeof value === 'object') {
        traverseAndFlatten(value, target, newKey);
      } else {
        target[newKey] = value;
      }
    }
  }
};

export const flatten = (obj: any) => {
  const flattenedObject = {};
  traverseAndFlatten(obj, flattenedObject);
  return flattenedObject;
};
